import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  Environment,
  ENVIRONMENT_TOKEN,
} from '../../../../apps/values/environment.token';
import { Therapist } from '../../../../apps/types/therapist';
import { MongoDBHttpService } from './mongodb-http/mongodb-http.service';

@Injectable({
  providedIn: 'root',
})
export class TherapistServiceNew {
  private _mongoHttpService = inject(MongoDBHttpService);
  private _environmentToken: Environment = inject(ENVIRONMENT_TOKEN);

  constructor() {}

  getTherapistProfile(userId: string): Observable<Therapist | null> {
    return this._mongoHttpService
      .db(this._environmentToken.databaseName)
      .collection<Therapist>(this._environmentToken.profilesCollection)
      .findOne({
        $or: [{ auth_zero_user_id: userId }, { owner_user_id: userId }],
      });
  }

  updateTherapistProfile(
    auth0UserId: string,
    therapistUpdate: object
  ): Observable<any> {
    return this._mongoHttpService
      .db(this._environmentToken.databaseName)
      .collection<Therapist>(this._environmentToken.profilesCollection)
      .updateOne(
        {
          auth_zero_user_id: auth0UserId,
        },
        {
          $set: {
            ...therapistUpdate,
          },
        }
      );
  }

  getTherapistEnrolledByAdminList(
    auth0AdminId: string
  ): Observable<Therapist[]> {
    return this._mongoHttpService
      .db(this._environmentToken.databaseName)
      .collection<Therapist>(this._environmentToken.profilesCollection)
      .find(
        {
          created_by_admin_user_id: auth0AdminId,
        },
        {
          sort: {
            _id: 1,
          },
        }
      );
  }

  getAllTherapistList(): Observable<Therapist[]> {
    return this._mongoHttpService
      .db(this._environmentToken.databaseName)
      .collection<Therapist>(this._environmentToken.profilesCollection)
      .find(
        {},
        {
          sort: {
            _id: 1,
          },
        }
      );
  }
}
